<template>
<v-container fluid>
<v-layout>
  <v-flex xs12>
   <v-alert
      value="message" v-if="message"
      type="success"
      outlined
    > <span> {{ message }} </span>
    </v-alert>
     <v-alert
      value="error" v-if="error"
      type="warning"
      outlined
    > <span> {{ error }} </span>
    </v-alert>
   <v-dialog v-model="dialog" max-width="500px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ request }} User Creation Request</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
           <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field
               v-model="editedItem.firstName"
               label="First Name"
               required
               readonly
               >
               </v-text-field>
              <v-text-field
               v-model="editedItem.lastName"
               label="Last Name"
               required
               readonly
               >
               </v-text-field>
              <v-text-field
               v-model="editedItem.username"
               label="Username"
               required
               readonly
               >
              </v-text-field>
              <v-text-field
               v-model="editedItem.role"
               label="Role"
               required
               readonly
               >
              </v-text-field>
                <v-text-field
               v-model="editedItem.department"
               label="Department"
               required
               readonly
               >
              </v-text-field>
            </v-form>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click.native="close">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click.native="save">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-card>
    <v-card-title>
      <v-spacer></v-spacer>
        <v-col cols="3">
        <v-text-field v-model="search" append-icon="search" label="Search"
          single-line hide-details color="primary"></v-text-field>
      </v-col>
    </v-card-title>
    <v-card-text>
    <v-data-table
        :headers="headers"
        :items="users"
        :search="search"
      >
      <template v-slot:[`item.created`]="{ item }">
        {{item.created | prettyDate }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
            color="primary"
            dark
            v-on="on"
            text
            icon
            class="actions"
          >
            <v-icon> more_horiz </v-icon>
          </v-btn>
          </template>
          <v-list>
            <v-list-item @click="approveItem(item)">
              <v-list-item-title> Approve </v-list-item-title>
            </v-list-item>
            <v-list-item @click="declineItem(item)">
              <v-list-item-title> Decline </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</v-flex>
</v-layout>
</v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'

export default {
  name: 'approveexternalusers',
  data: function () {
    return {
      headers: [
        { text: 'First Name', value: 'firstName' },
        { text: 'Last Name', value: 'lastName' },
        { text: 'Username', value: 'username' },
        { text: 'Role', value: 'role' },
        { text: 'Account Status', value: 'accountStatus' },
        { text: 'Profile Status', value: 'active' },
        { text: 'Maker Username', value: 'makerUsername' },
        { text: 'Request Type', value: 'requestType' },
        { text: 'Department', value: 'Department' },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      users: [],
      message: '',
      error: '',
      loading: true,
      pagination: {},
      totalUsers: 0,
      dialog: false,
      editedIndex: -1,
      defaultItem: {
        id: '',
        firstName: '',
        lastName: '',
        username: '',
        role: '',
        accountStatus: '',
        active: ''
      },
      editedItem: {
        id: '',
        firstName: '',
        lastName: '',
        username: '',
        role: '',
        accountStatus: '',
        active: '',
        comment: '',
        approvalStatus: ''
      },
      valid: true,
      request: '',
      search: ''
    }
  },
  watch: {
    pagination: {
      handler () {
        this.getDataFromApi()
          .then(data => {
          })
      },
      deep: true
    }
  },
  mounted () {
    this.getDataFromApi()
      .then(data => {
      })
  },
  methods: {
    getDataFromApi () {
      this.loading = true
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        let items = this.getUsers()
        const total = items.length

        if (this.pagination.sortBy) {
          items = items.sort((a, b) => {
            const sortA = a[sortBy]
            const sortB = b[sortBy]

            if (descending) {
              if (sortA < sortB) return 1
              if (sortA > sortB) return -1
              return 0
            } else {
              if (sortA < sortB) return -1
              if (sortA > sortB) return 1
              return 0
            }
          })
        }

        if (rowsPerPage > 0) {
          items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage)
        }

        setTimeout(() => {
          this.loading = false
          resolve({
            items,
            total
          })
        }, 1000)
      })
    },
    approveItem (item) {
      this.editedIndex = this.users.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
      this.request = 'Approve'
      this.editedItem.approvalStatus = 'approved'
    },
    declineItem (item) {
      this.editedIndex = this.users.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
      this.request = 'Decline'
      this.editedItem.approvalStatus = 'declined'
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      if (this.$refs.form.validate()) {
        if (this.editedItem.approvalStatus === 'approved') {
          this.sendRequest('approve')
        } else if (this.editedItem.approvalStatus === 'declined') {
          this.sendRequest('decline')
        }
        this.close()
      }
    },
    sendRequest (request) {
      var url = config.serverURI + '/user/internaluser/' + request
      this.message = ''
      console.log(this.editedItem)
      axios.post(url, this.editedItem)
        .then(response => {
          console.log('Update Response:', response)
          if (response.data.error !== false) {
            this.error = response.data.message
            console.log('Error is ' + this.error)
            return
          }
          this.users = this.getUsers()
          this.message = response.data.message
        })
        .catch(error => {
          // Request failed.
          console.log('error', error.response)
          var data = error.response.data
          console.log(data.message)
          if (data.message === 'Unauthorized') {
            console.log('redirecting')
            window.location = '/login'
          } else {
            this.error = data.message
          }
        })
    },
    getUsers () {
      console.log("getUsersInternal")
      var url = config.serverURI + '/user/internaluser/unapproved'
      var token = store.state.token
      axios.get(url, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json'
        }
      })
        .then(response => {
          console.log('API Response-:', response)

          if (response.status !== 200) {
            this.error = response.statusText
            console.log('Error is ' + this.error)
            return
          }
          this.users = response.data
        })
        .catch(error => {
          // Request failed.
          console.log('error', error.response)
          var data = error.response.data
          console.log(data.message)
          if (data.message === 'Unauthorized') {
            console.log('redirecting')
            window.location = '/login'
          } else {
            this.error = data.message
          }
        })
      return this.users
    }
  }
}

</script>
<style>
</style>
